import { render, staticRenderFns } from "./blackList.vue?vue&type=template&id=3b43fd60&scoped=true&"
import script from "./blackList.vue?vue&type=script&lang=js&"
export * from "./blackList.vue?vue&type=script&lang=js&"
import style0 from "./blackList.vue?vue&type=style&index=0&id=3b43fd60&prod&lang=less&scoped=true&"
import style1 from "./blackList.vue?vue&type=style&index=1&id=3b43fd60&prod&lang=less&"
import style2 from "./blackList.vue?vue&type=style&index=2&id=3b43fd60&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b43fd60",
  null
  
)

export default component.exports